<template>
  <div>
    <div v-if="id">
      <transition name="mode-fade" mode="out-in">
        <AddressComponent
          v-if="id == 'address'"
          :key="newSteps[id].id"
          :value="value[newSteps[id].id]"
          :buttonLabel="newSteps[id].buttonLabel"
          :label="newSteps[id].label"
          :errMsg="newSteps[id].errMsg"
          :placeHolder="newSteps[id].placeHolder"
          :zipLabel="newSteps[id].zipLabel"
          :zipErrMsg="newSteps[id].zipErrMsg"
          :zipPlaceHolder="newSteps[id].zipPlaceHolder"
          @submit="submit($event, 'address')"
        />
        <AgeComponent
          v-else-if="id == 'age'"
          :key="newSteps[id].id"
          :value="value[newSteps[id].id]"
          :lastStep="lastStep"
          :ageLabel="newSteps[id].ageLabel"
          :confirmLabel="newSteps[id].confirmLabel"
          :secondAgeLabel="newSteps[id].secondAgeLabel"
          :ageErrMsg="newSteps[id].ageErrMsg"
          :confirmErrMsg="newSteps[id].confirmErrMsg"
          :agePlaceHolder="newSteps[id].agePlaceHolder"
          :confirmPlaceHolder="newSteps[id].confirmPlaceHolder"
          :minAge="newSteps[id].minAge"
          :state="value['address']['state']"
          @submit="submit($event, 'age')"
        />
        <CustomCard
          v-else
          :key="newSteps[id].id"
          :type="newSteps[id].type"
          :lastStep="lastStep"
          :label="newSteps[id].label"
          :placeHolder="newSteps[id].placeHolder"
          :errMsg="newSteps[id].errMsg"
          :options="newSteps[id].options"
          :value="value[newSteps[id].id]"
          :required="newSteps[id].required"
          @submit="submit($event, newSteps[id].id)"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import CustomCard from "./CustomCard.vue";
import AddressComponent from "./AddressComponent.vue";
import AgeComponent from "./AgeComponent.vue";
export default {
  components: {
    AddressComponent,
    AgeComponent,
    CustomCard,
  },
  props: ["value", "id", "lastStep"],
  data() {
    return {
      newSteps: {
        address: {
          id: "address",
          buttonLabel: "Continue",
          buttonIcon: true,
          label: "What's your property street address?*",
          placeHolder: "Enter street address",
          errMsg: "Please provide a valid address",
          zipLabel: "What is your zipcode?*",
          zipPlaceHolder: "Enter zipcode",
          zipErrMsg: "Please provide a valid zipcode",
        },
        propertyValue: {
          id: "propertyValue",
          required: true,
          type: "select",
          buttonLabel: "Continue",
          buttonIcon: true,
          label: "What's the estimated property value?*",
          placeHolder: "Select Property Value",
          errMsg: "Please select property value.",
          options: {
            99999: "Less than $100,000",
            150000: "$100,000-$150,000",
            200000: "$150,000-$200,000",
            250000: "$200,000-$250,000",
            300000: "$250,000-$300,000",
            350000: "$300,000-$350,000",
            400000: "$350,000-$400,000",
            450000: "$400,000-$450,000",
            500000: "$450,000-$500,000",
            550000: "$500,000-$550,000",
            600000: "$550,000-$600,000",
            650000: "$600,000-$650,000",
            700000: "$650,000-$700,000",
            750000: "$700,000-$750,000",
            800000: "$750,000-$800,000",
            850000: "$800,000-$850,000",
            900000: "$850,000-$900,000",
            950000: "$900,000-$950,000",
            1000000: "$950,000-$1,000,000",
            1050000: "$1,000,000-$1,050,000",
            1100000: "$1,050,000-$1,100,000",
            1150000: "$1,100,000-$1,150,000",
            1200000: "$1,150,000-$1,200,000",
            1250000: "$1,200,000-$1,250,000",
            1300000: "$1,250,000-$1,300,000",
            1350000: "$1,300,000-$1,350,000",
            1400000: "$1,350,000-$1,400,000",
            1450000: "$1,400,000-$1,450,000",
            1500000: "$1,450,000-$1,500,000",
            1550000: "$1,500,000-$1,550,000",
            1600000: "$1,550,000-$1,600,000",
            1650000: "$1,600,000-$1,650,000",
            1700000: "$1,650,000-$1,700,000",
            1750000: "$1,700,000-$1,750,000",
            1800000: "$1,750,000-$1,800,000",
            1850000: "$1,800,000-$1,850,000",
            1900000: "$1,850,000-$1,900,000",
            1950000: "$1,900,000-$1,950,000",
            2000000: "$1,950,000-$2,000,000",
            2050000: "$2,000,000-$2,050,000",
            2100000: "$2,050,000-$2,100,000",
            2150000: "$2,100,000-$2,150,000",
            2200000: "$2,150,000-$2,200,000",
            2250000: "$2,200,000-$2,250,000",
            2300000: "$2,250,000-$2,300,000",
            2350000: "$2,300,000-$2,350,000",
            2400000: "$2,350,000-$2,400,000",
            2450000: "$2,400,000-$2,450,000",
            2500000: "$2,450,000-$2,500,000",
            2500001: "More than $2,500,000",
          },
        },
        mortgageBalance: {
          id: "mortgageBalance",
          required: true,
          type: "select",
          buttonLabel: "Continue",
          buttonIcon: true,
          label: "What is your current mortgage balance?*",
          placeHolder: "Select Mortgage Balance",
          errMsg: "Please select mortgage balance.",
          options: {
            0: "$0 - $10,000",
            10001: "$10,001 - $20,000",
            20001: "$20,001 - $30,000",
            30001: "$30,001 - $40,000",
            40001: "$40,001 - $50,000",
            50001: "$50,001 - $60,000",
            60001: "$60,001 - $70,000",
            70001: "$70,001 - $80,000",
            80001: "$80,001 - $90,000",
            90001: "$90,001 - $100,000",
            100001: "$100,001 - $110,000",
            110001: "$110,001 - $120,000",
            120001: "$120,001 - $130,000",
            130001: "$130,001 - $140,000",
            140001: "$140,001 - $150,000",
            150001: "$150,001 - $160,000",
            160001: "$160,001 - $170,000",
            170001: "$170,001 - $180,000",
            180001: "$180,001 - $190,000",
            190001: "$190,001 - $200,000",
            200001: "$200,001 - $225,000",
            225001: "$225,001 - $250,000",
            250001: "$250,001 - $275,000",
            275001: "$275,001 - $300,000",
            300001: "$300,001 - $325,000",
            325001: "$325,001 - $350,000",
            350001: "$350,001 - $375,000",
            375001: "$375,001 - $400,000",
            400001: "$400,001 - $425,000",
            425001: "$425,001 - $450,000",
            450001: "Over $450,000",
          },
        },
        age: {
          id: "age",
          buttonLabel: "Continue",
          buttonIcon: true,
          ageLabel: "What is the current age of the homeowner on title?*",
          confirmLabel: "Are you inquiring for someone xx years or older?*",
          secondAgeLabel:
            "What is the age of the person you're inquiring for?*",
          ageErrMsg: "Please select age",
          confirmErrMsg: "Please select answer",
          agePlaceHolder: "Select age",
          confirmPlaceHolder: "Select answer",
          minAge: {
            AL: 62,
            AK: 62,
            AS: 62,
            AZ: 55,
            AR: 62,
            CA: 55,
            CO: 55,
            CT: 55,
            DE: 62,
            DC: 55,
            FM: 62,
            FL: 55,
            GA: 55,
            GU: 62,
            HI: 55,
            ID: 55,
            IL: 55,
            IN: 62,
            IA: 62,
            KS: 62,
            KY: 62,
            LA: 55,
            ME: 62,
            MH: 62,
            MD: 62,
            MA: 60,
            MI: 55,
            MN: 62,
            MS: 62,
            MO: 62,
            MT: 62,
            NE: 62,
            NV: 55,
            NH: 62,
            NJ: 55,
            NM: 62,
            NY: 62,
            NC: 62,
            ND: 62,
            MP: 62,
            OH: 55,
            OK: 62,
            OR: 55,
            PW: 62,
            PA: 55,
            PR: 62,
            RI: 55,
            SC: 55,
            SD: 55,
            TN: 62,
            TX: 62,
            UT: 62,
            VT: 62,
            VI: 62,
            VA: 55,
            WA: 60,
            WV: 62,
            WI: 62,
            WY: 62,
          },
        },
        fullname: {
          id: "fullname",
          required: true,
          type: "name",
          buttonLabel: "Continue",
          buttonIcon: true,
          label: "What is your first and last name?*",
          placeHolder: "Enter first and last name",
          errMsg: "Please provide a valid name",
        },
        phone: {
          id: "phone",
          required: true,
          type: "tel",
          buttonLabel: "Continue",
          buttonIcon: true,
          label: "What's your phone number?*",
          placeHolder: "Enter phone number",
          errMsg: "Please provide a valid phone number",
        },
        email: {
          id: "email",
          required: false,
          type: "text",
          buttonLabel: "Get Free Guide",
          buttonIcon: false,
          label: "What's your email address (optional)?",
          placeHolder: "Enter email address",
          errMsg: "Please provide a valid email address",
        },
      },
    };
  },
  methods: {
    submit: function (value) {
      this.$emit("submit", value);
    },
  },
};
</script>
